import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import * as dynamicPagesSelectors from './dynamic-pages.selectors';
import { newEvent } from './dynamic-pages.actions';
import { SystemEntity } from '@wdx/shared/swagger-gen';
import { DynamicPagesEventTypes } from './dynamic-pages.reducer';

@Injectable({ providedIn: 'root' })
export class DynamicPagesFacade {
    constructor(private store$: Store) {}

    public getNewEvents$(timestamp: number = Date.now()) {
        return this.store$
            .select(dynamicPagesSelectors.getLatestEvent)
            .pipe(
                filter(
                    (event) => event?.timestamp && event.timestamp > timestamp,
                ),
            );
    }

    public createNewEvent(
        entityType: SystemEntity,
        eventType: DynamicPagesEventTypes = DynamicPagesEventTypes.Reload,
    ) {
        this.store$.dispatch(newEvent({ entityType, eventType }));
    }
}
